import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const detail = params => request({
  url: '/api/mcc-staff/positiverecord/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const extendedProbation = params => request({
  url: '/api/mcc-staff/positiverecord/extendedProbation',
  method: 'post',
  data: {
    ...params,
  },
})
const remove = data => request({
  url: '/api/mcc-staff/positiverecord/remove',
  method: 'post',
  params: data
})
const close = params => request({
  url: '/api/mcc-staff/positiverecord/close',
  method: 'post',
  params: {
    ...params,
  },
})

const sendPassMessage = params => request({
  url: '/api/mcc-staff/positiverecord/sendPassMessage',
  method: 'post',
  params: {
    ...params,
  },
})

const getConfirmationAssessmentRecord = params => request({
  url: '/api/mcc-staff/positiverecord/getConfirmationAssessmentRecord',
  method: 'get',
  params: {
    ...params,
  },
})

const exportExcel = params => request({
  url: '/api/mcc-staff/positiverecord/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

const getNotice = params => request({
  url: '/api/mcc-staff/positiverecord/getNotice',
  method: 'get',
  params: {
    ...params,
  },
})

export const pageProbationStaff = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/pageProbationStaff',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const statisticsProbationStaff = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/statisticsProbationStaff',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const pageRenewalContractstaff = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/pageRenewalContractStaff',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const statisticsRenewalContractStaff = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/statisticsRenewalContractStaff',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
export const statisticsPendingForLeaderApproval = params => request({
  url: '/api/mcc-staff/positiverecord/statisticsPendingForLeaderApproval',
  method: 'get',
  params: {
    ...params,

  },
})
export const statisticsSuccessfulLeaderApproval = params => request({
  url: '/api/mcc-staff/positiverecord/statisticsSuccessfulLeaderApproval',
  method: 'get',
  params: {
    ...params,

  },
})
const startConfirmationAssessment = params => request({
  url: '/api/mcc-staff/positiverecord/startConfirmationAssessment',
  method: 'post',
  data: {
    ...params,

  },
})

const saveConfirmationAssessment = params => request({
  url: '/api/mcc-staff/positiverecord/saveConfirmationAssessment',
  method: 'post',
  data: {
    ...params,

  },
})
const sendNotification = params => request({
  url: '/api/mcc-staff/positiverecord/sendNotification',
  method: 'post',
  data: {
    ...params,

  },
})

const closeConfirmationAssessment = params => request({
  url: '/api/mcc-staff/positiverecord/closeConfirmationAssessment',
  method: 'post',
  data: {
    ...params,
  },
})
const removeConfirmationAssessment = params => request({
  url: '/api/mcc-staff/positiverecord/removeConfirmationAssessment',
  method: 'post',
  data: {
    ...params,
  },
})

const exportExcelByProbation = params => request({
  url: '/api/mcc-staff/positiverecord/exportProbationStaff',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})
const getByIds = params => request({
  url: '/api/mcc-staff/positiverecord/getByIds',
  method: 'get',
  params: {
    ...params,
  },
})
const exportExcelByRenewal = params => request({
  url: '/api/mcc-staff/positiverecord/exportRenewalContractStaff',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})
export default {
  getList,
  detail,
  extendedProbation,
  close,
  sendPassMessage,
  getConfirmationAssessmentRecord,
  exportExcel,
  getNotice,
  pageProbationStaff,
  pageRenewalContractstaff,
  statisticsRenewalContractStaff,
  statisticsProbationStaff,
  startConfirmationAssessment,
  statisticsPendingForLeaderApproval,
  statisticsSuccessfulLeaderApproval,
  saveConfirmationAssessment,
  sendNotification,
  closeConfirmationAssessment,
  exportExcelByProbation,
  exportExcelByRenewal,
  getByIds,
  remove,
  removeConfirmationAssessment,
}
